$( document ).ready(function() {
	var site_url = $("body").data("site-url");

	// FUNCTIONS
	$('a[data-rel^=lightcase]').lightcase();

	// WINDOW ON LOAD
	$(window).on("load", function(){
		caroufredsel_slider();
		footerAccordion();
        shippingoptions();
		// SITE LOADER
		$(".site-loader").css("opacity", 0);
		setTimeout(function(){
			$(".site-loader").css("z-index", -1);
		}, 300);
	});

	// WINDOW ON RESIZE
	$(window).on("resize", function(){
    	caroufredsel_slider();
    	footerAccordion();
  	});

  	// FRONT PAGE MEET OUR TEAM
  	$(".owl-carousel").each(function(){
  		var $this = $(this);
  		$this.owlCarousel({
  			loop: false,
  			responsiveClass: true,
  			autoWidth:true,
  			nav: false,
  			dots: false,
  			responsive:{
  				0:{
  					margin: 10
  				},
  				768:{
		  			rtl: true,
		  			margin: 15
  				},
  				992:{
		  			rtl: true,
		  			margin: 20
  				},
  				1200:{
		  			rtl: true,
  					margin: 30
  				}
  			}
  		});
  	});

  	// CIRCLE PARTICELS
  	var template_url = $('body').data('template-url');
  	particlesJS.load('particles-circle', template_url + '/../assets/js/vendor/particles-circle.json', function() {
	  // console.log('callback - particles.js config loaded');
	});
	// TRIANGLE PARTICLES
	particlesJS.load('particles-triangle', template_url + '/../assets/js/vendor/particles-triangle.json', function() {
	  // console.log('callback - particles.js config loaded');
	});

  	// AOS INIT
	AOS.init();


  	// FOOTER ACCORDION
  	function footerAccordion(){
  		if ( Modernizr.mq("(min-width: 992px)") ) {
			$("#footer").removeClass("footer-menu");
			$("#footer .widget_nav_menu .menu").slideDown();
  		} else {
			$("#footer").addClass("footer-menu");
			$("#footer .footer-col").each(function(){
    			if ( !$(this).find(".widget_nav_menu").hasClass("active") ) {
					$(this).find(".widget_nav_menu .menu").css("display", "none");
    			}
    		});
  		}
  	}
  	$("body").on("click", "#footer .widget_nav_menu .widget-title", function(){
    	if ( $(this).closest(".widget_nav_menu").hasClass("active") ) {
    		$(this).closest(".widget_nav_menu").removeClass("active");
    		$(this).closest(".widget_nav_menu").find(".menu").slideUp();
    	} else {
    		$(this).closest(".widget_nav_menu").addClass("active");
    		$(this).closest(".widget_nav_menu").find(".menu").slideDown();
    	}
  	});

  	// SHOP PAGE TAB CATEGORIES / BRANDS
  	$("body").on("click", ".shop-section .shop-section-header ul li a", function(e){
  		e.preventDefault();

  		$this = $(this).closest("li");
  		$tab  = $(this).closest("li").data("tab");

  		$(this).closest("ul").find("li").removeClass("active");
  		$(".shop-tab-content").removeClass("active");

  		$(".shop-tab-content").each(function(){
  			if ( $(this).hasClass($tab) ) {
  				$(this).addClass("active");
  			}
  		});

  		if ( $this.hasClass("active") ) {
	  		$(this).closest("li").removeClass("active");
  		} else {
	  		$(this).closest("li").addClass("active");
  		}
  	});

  	// TAX PRODUCT CAT LOAD MORE
  	var ajax_url = $("body").data("ajax-url");
  	$("body").on("click", ".load-more-products a", function(e){
  		e.preventDefault();

  		var $this     = $(this);
  		var offset    = $(".products-wrap").data("product-offset");
  		var postType  = $this.closest(".load-more-products").data("post-type");
  		var ppp       = $this.closest(".load-more-products").data("posts-per-page");
  		var taxonomy  = $this.closest(".load-more-products").data("taxonomy");
  		var termID    = $this.closest(".load-more-products").data("taxonomy-term-id");
  		var type      = $this.closest(".load-more-products").data("product-type");

  		// alert(type);

  		if ( !$this.hasClass("empty") ) {
	  		$this.siblings(".load-more-loader").removeClass("d-none");
	  		$this.addClass("d-none");

	  		$.ajax({
	  			url: ajax_url,
	  			type: "POST",
	  			dataType: "json",
	  			data:{
	  				action: "tax_product_cat_load_more",
	  				offset: offset,
	  				postType: postType,
	  				taxonomy: taxonomy,
	  				termID: termID,
	  				ppp: ppp,
	  				type: type,
	  			},
	  			beforeSend: function(){},
	  			success: function(response){
	  				$this.siblings(".load-more-loader").addClass("d-none");
	  				$this.removeClass("d-none");
	  				$(".products-wrap").append(response.content);
	  				$(".products-wrap").attr("data-product-offset", response.offset);
	  				$(".products-wrap").data("product-offset", response.offset);
	  				$('.product-item .product-info').matchHeight({
	  					byRow: true,
	  				});

	  				if ( response.empty ) {
		  				$this.addClass("empty");
		  				$this.html("No more products to load.");
	  				}
	  			}
	  		});
  		}

  	});

  	// ADD SINGLE PRODUCT TO CART
  	toastr.options = {
  		"positionClass": "toast-bottom-right",
  	}
  	$("body").on("click", ".add-to-cart", function(e){
  		e.preventDefault();

  		var $this     = $(this);
  		var productID = $this.closest(".product-item").data("product-id");
  		var inStock   = $this.closest(".product-item").data("stock-status");

  		if ( inStock == "1" ) {
	  		$this.closest(".product-item").addClass("loading");
	  		$.ajax({
	  			url: ajax_url,
	  			type: "POST",
	  			data: {
	  				action: "product_add_to_cart",
	  				productID: productID,
	  			},
	  			beforeSend: function(){},
	  			success: function(response){
			  		$this.closest(".product-item").removeClass("loading");
			  		toastr.success('Product added to your cart.');
			  		$(".header.shop-header .cart-menu .cart-items").html( "(" + response + ")" );
	  			}
	  		});
  		} else {
  			toastr.error('Product is not in stock.');
  		}
  	});

  	// TAX PRODUCT CAT SIDEBAR
  	$(".product-cat-sidebar").on("click", ".sidebar-brands .sidebar-title, .sidebar-categories .sidebar-title", function(){
  		// alert();
  		var $this = $(this);
  		// $(".sidebar-item").removeClass("active");

  		if ( $this.closest(".sidebar-item").hasClass("active") ) {
  			$this.closest(".sidebar-item").removeClass("active");
  			$this.closest(".sidebar-item").find(".sidebar-terms").slideUp();
  		} else {
  			$this.closest(".sidebar-item").addClass("active");
  			$this.closest(".sidebar-item").find(".sidebar-terms").slideDown();
  		}
  	});

  	// SINGLE PRODUCT SCRIPTS
  	if ( $("body").hasClass("single-product") ) {
	  	// SINGLE PRODUCT QUANTITY FIELD
  		$(".quantity input").val(1);
	  	$("body").on("click", ".single-product-buttons .minus", function(){
	  		var val = parseInt( $(this).siblings(".spb-number").find("input").val() );
	  		if (val > 1) {
				$(this).siblings(".spb-number").find("input").val(val-1);
				$(".quantity").find("input").val( $(this).siblings(".spb-number").find("input").val() );
			}
	  	});
	  	$("body").on("click", ".single-product-buttons .plus", function(){
	  		var max = $(this).closest(".spb-quantity").data("stock");
			var val = parseInt( $(this).siblings(".spb-number").find("input").val() );

			if ( val < max ) {
				$(this).siblings(".spb-number").find("input").val(val+1);
				$(".quantity").find("input").val( $(this).siblings(".spb-number").find("input").val() );
			}
			if ( val == max ) {
				toastr.warning("This product has only " + val + " in stock.");
			}
	  	});
	  	// SINGLE PRODUCT ADD TO CART
	  	$("body").on("click", ".spb-add-to-cart a", function(e){
	  		e.preventDefault();
	  		$(".cart button.single_add_to_cart_button").trigger("click");
	  	});
	  	// SINGLE PRODUCT REVIEW FORM PLACEHOLDER TEXT
	  	$("#comment").attr("placeholder", "Your Review");
	  	$("#author").attr("placeholder", "Name");
	  	$("#email").attr("placeholder", "Your Email");
  	}


  	// PRODUCTS INQUIRE FORM
  	if ( $(".product-catalog-item").length > 0 ) {
  		var productName = $("#productName").val();
  		$(".inquire-form input[name=product-name]").val(productName);
  		$(".inquire-form input[name=product-name]").attr("readonly", "readonly");
  	}

  	// LOGIN & REGISTER MODAL
  	$(".modal").on("click", ".open-register-modal", function(e){
  		e.preventDefault();
  		$("#loginModal").modal("hide");
  		$("#registerModal").modal("show");
  	});
  	$(".modal").on("click", ".open-login-modal", function(e){
  		e.preventDefault();
  		$("#registerModal").modal("hide");
  		$("#loginModal").modal("show");
  	});
  	$(".menu").on("click", ".login-menu", function(e){
  		e.preventDefault();
  		$("#loginModal").modal("show");
  	});
  	$(".menu").on("click", ".register-menu", function(e){
  		e.preventDefault();
  		$("#registerModal").modal("show");
  	});
  	$(".modal-form input").on("focus", function(){
  		$(this).removeClass("error");
  	});
  	// register form submit
  	$("#registerModal").on("submit", function(e){
  		e.preventDefault();

  		var formData = $('.register-form').serializeArray();
  		var password = $("#registerPassword").val();
  		var passwordConfirm = $("#registerPasswordConfirm").val();

  		// hide form error div
  		$(".modal .modal-error").removeClass("active");
  		// remove error class on input
  		$("#registerModal input").removeClass("error");

  		if ( password == passwordConfirm ) {
	  		$("#registerModal .modal-loader").addClass("active");
	  		$("#registerModal .modal-error").removeClass("alert-success");
	  		$("#registerModal .modal-error").addClass("alert-danger");
	  		$("#registerModal .modal-error .fas").removeClass("fa-check-circle").addClass("fa-exclamation-circle");
	  		
	  		$.ajax({
	  			url: ajax_url,
	  			dataType: "json",
	  			type: "POST",
	  			data:{
	  				action: "custom_register_user",
	  				formData: formData
	  			},
	  			beforeSend: function(){},
	  			success: function(response){
	  				console.log(response);

	  				if ( response.usernameError && response.emailError ) {
	  					$("#registerUsername").addClass("error");
	  					$("#registerEmail").addClass("error");
	  					$("#registerModal .modal-error").addClass("active");
	  					$("#registerModal .modal-error .text").html("The username and email you entered has already been used.");
	  				} else if ( response.usernameError ) {
						$("#registerUsername").addClass("error");
	  					$("#registerModal .modal-error").addClass("active");
	  					$("#registerModal .modal-error .text").html("The username you entered has already been used.");
	  				} else if ( response.emailError ) {
	  					$("#registerEmail").addClass("error");
	  					$("#registerModal .modal-error").addClass("active");
	  					$("#registerModal .modal-error .text").html("The email you entered has already been used.");
	  				}

	  				if ( response.success ) {
	  					$("#registerModal input").val("");
	  					$("#registerModal input").removeClass("error");
	  					$("#registerModal .modal-error").removeClass("alert-danger");
	  					$("#registerModal .modal-error").addClass("alert-success");
	  					$("#registerModal .modal-error").addClass("active");
	  					$("#registerModal .modal-error").html("<i class='fas fa-check-circle'></i> <span class='text'>You have successfully created your account. <a href='' class='open-login-modal'>Login Here.</a></span>");
	  				}

	  				$("#registerModal .modal-loader").removeClass("active");
	  			}
	  		});
  		} else {
  			$("#registerPassword").addClass("error");
  			$("#registerPasswordConfirm").addClass("error");
  			$("#registerModal .modal-error").addClass("active");
  			$("#registerModal .modal-error .text").html("Password is not valid.");
  		}
  	});
  	// login form submit
  	$("#loginModal").on("submit", function(e){
  		e.preventDefault();

  		// active modal loader
  		$("#loginModal .modal-loader").addClass("active");

  		$("#loginModal .modal-error").removeClass("alert-success");
  		$("#loginModal .modal-error").addClass("alert-danger");
  		$("#loginModal .modal-error .fas").removeClass("fa-check-circle").addClass("fa-exclamation-circle");

  		var emailUser = $('#loginUsername').val();
  		var password  = $('#loginPassword').val();

  		// check if the user data is an email or a normal username
  		if ( emailUser.match(/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/) ) {
  			var userType = "email";
  		} else {
  			var userType = "username";
  		}

  		$.ajax({
  			url: ajax_url,
  			dataType: "json",
  			type: "POST",
  			data:{
  				action: "custom_login_user",
  				emailUser: emailUser,
  				password: password,
  				userType: userType,
  			},
  			beforeSend: function(){},
  			success: function(response){
  				console.log(response);

  				if ( response.error !== null ) {
  					$("#loginModal .modal-error").addClass("active");
  					$("#loginModal .modal-error .text").html("Username or Password is not valid.");
  				}

  				if ( response.success ) {
  					$("#loginModal input").val("");
  					$("#loginModal input").removeClass("error");
  					$("#loginModal .modal-error").removeClass("alert-danger");
  					$("#loginModal .modal-error").addClass("alert-success");
  					$("#loginModal .modal-error").addClass("active");
  					$("#loginModal .modal-error").html("<i class='fas fa-check-circle'></i> <span class='text'>Login success. You will be redirected in a few seconds.</span>");
  					
  					window.location = site_url + "/my-account";
  				}

  				$("#loginModal .modal-loader").removeClass("active");
  			}
  		});
  	});

    // OFFCANVAS MENU
    $(".offcanvas-menu .menu-item-has-children").append("<div class='menu-arrow'><span class='fa fa-caret-down'></span></div>");
    $(".offcanvas-menu").on("click", ".menu-item-has-children > .menu-arrow", function(){
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".sub-menu").slideUp();
        } else {
            $(this).addClass("active");
            $(this).siblings(".sub-menu").slideDown();
        }
    });
    $(".offcanvas-menu").on("click", ".om-close", function(){
      $(".header .bars").removeClass("active");
      $(".offcanvas-menu").removeClass("active");
    });
    $(".header").on("click", ".menu-bar", function(){
        if ( $(this).hasClass("active") ) {
            $(this).removeClass("active");
            $(".offcanvas-menu").removeClass("active");
        } else {
            $(this).addClass("active");
            $(".offcanvas-menu").addClass("active");
        }
    });


  	// IOS INPUT BUG FIX
    (function iOS_CaretBug() {
       var ua = navigator.userAgent,
       scrollTopPosition,
       iOS = /iPad|iPhone|iPod/.test(ua),
       iOS11 = /OS 11_0|OS 11_1|OS 11_2/.test(ua);

       // ios 11 bug caret position
       if ( iOS && iOS11 ) {

           $(document.body).on('show.bs.modal', function(e) {
               if ( $(e.target).hasClass('modal') ) {
                   // Get scroll position before moving top
                   scrollTopPosition = $(document).scrollTop();

                   // Add CSS to body "position: fixed"
                   $("body").addClass("iosBugFixCaret");
               }
           });

           $(document.body).on('hide.bs.modal', function(e) {
               if ( $(e.target).hasClass('modal') ) {
                   // Remove CSS to body "position: fixed"
                   $("body").removeClass("iosBugFixCaret");

                   //Go back to initial position in document
                   $(document).scrollTop(scrollTopPosition);
               }
           });
       }
    })();

    // CAROUFREDSEL SLIDER
	function caroufredsel_slider() {
		$(".cs-slider .slides").each(function(){
			var $this    = $(this);
			var ctrlPrev = $(this).closest(".cs-slider").find(".prev");
			var ctrlNext = $(this).closest(".cs-slider").find(".next");

			$this.carouFredSel({
				auto: {
					play: $this.data("auto"),
					timeoutDuration: $this.data("duration"),
				},
				start      : "random",
				width      : $this.data("cs-width"),
				circular   : $this.data("cs-circular"),
				infinite   : $this.data("cs-infinite"),
				height     : $this.data("cs-height"),
				responsive : $this.data("cs-responsive"),
				direction  : $this.data("cs-direction"),
				prev       : ctrlPrev,
				next       : ctrlNext,
				pagination : "."+$this.data("paginate"),
				scroll:{
					items: $this.data("item-scroll"),
					fx   : $this.data("effects"),
				},
				items:{
				  height : $this.data("item-height"),
				  width  : $this.data("item-width"),
				  visible: {
				    	min: $this.data("min"),
				    	max: $this.data("max")
				  },
				},
				swipe:true,
			});

			$this.touchwipe({
				wipeUp: function(e) {
				 	e.preventDefault();
				},
				wipeDown: function(e) {
				 	e.preventDefault();
				},
				wipeLeft: function(e) {
				 	$this.trigger("next", 1);
				},
				wipeRight: function(e) {
				 	$this.trigger("prev", 1);
				}
			});
		});
	}
});


function shippingoptions() {
    $( '.woocommerce-account-fields .checkbox' ).on('click','input',function(){
        $(this).closest('.note').toggleClass('f-active');
    });
    $('.cust-checkout-wrapper .inner-shipping #ship-to-different-address label .note').on('click','input',function(){
        $(this).parent().toggleClass('f-active');
    });

}